<template>
  <div class="wrapper">
    <div class="title">{{ title }}</div>
    <div class="value">
      <label for="">RGB ({{ colorRGB }})</label>
      <input type="color" name="" id="" v-model="color" />
    </div>
  </div>
</template>

<script>
import { store } from "@/store/scene.js";
export default {
  name: "Picker",
  components: {},
  props: ["title", "prop"],
  data() {
    return {
      color: "#ffffff",
      store,
    };
  },
  methods: {
    hexToRgb(hex) {
      return hex
        .replace(
          /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
          (m, r, g, b) => "#" + r + r + g + g + b + b
        )
        .substring(1)
        .match(/.{2}/g)
        .map((x) => parseInt(x, 16));
    },
    rgbToHex(r, g, b) {
      return (
        "#" + [r, g, b].map((x) => x.toString(16).padStart(2, "0")).join("")
      );
    },
  },
  computed: {
    colorRGB() {
      let rgb = this.hexToRgb(this.color);
      return rgb.toString();
    },
  },
  mounted() {
    if (store[this.prop]) this.color = this.rgbToHex(...store[this.prop]);
  },
  watch: {
    color(newColor, oldColor) {
      if (newColor !== oldColor) store[this.prop] = this.hexToRgb(this.color);
    },
  },
};
</script>

<style scoped>
.title {
  font-size: 2rem;
  margin-bottom: 1rem;
  letter-spacing: -0.6px;
}
.value {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  position: relative;
}
input {
  cursor: pointer;
  width: 4rem;
  height: 4rem;
  padding: 0;
  border: none;
  position: absolute;
  right: 0;
}
</style>